import React from "react";
import { type RouteObject } from "react-router-dom";
import { HomePage } from "@pages/HomePage/HomePage";
import { AuthLayout } from "@components/layouts/AuthLayout/AuthLayout";

const SignUpPage = React.lazy(() =>
  import("@pages/SignUpPage/SignUpPage").then((module) => ({
    default: module.SignUpPage,
  })),
);

const LoginPage = React.lazy(() =>
  import("@pages/LoginPage/LoginPage").then((module) => ({
    default: module.LoginPage,
  })),
);

const ForgotPasswordPage = React.lazy(() =>
  import("@pages/ForgotPasswordPage/ForgotPasswordPage").then((module) => ({
    default: module.ForgotPasswordPage,
  })),
);

const ResetPasswordPage = React.lazy(() =>
  import("@pages/ResetPasswordPage/ResetPasswordPage").then((module) => ({
    default: module.ResetPasswordPage,
  })),
);

export const publicRoutes: RouteObject = {
  element: <AuthLayout />,
  children: [
    {
      path: "*",
      element: <HomePage />,
    },
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/login",
      element: (
        <React.Suspense fallback={<></>}>
          <LoginPage />
        </React.Suspense>
      ),
    },
    {
      path: "/signup/:referralCode?",
      element: (
        <React.Suspense fallback={<></>}>
          <SignUpPage />
        </React.Suspense>
      ),
    },
    {
      path: "/forgot",
      element: (
        <React.Suspense fallback={<></>}>
          <ForgotPasswordPage />
        </React.Suspense>
      ),
    },
    {
      path: "/reset",
      element: (
        <React.Suspense fallback={<></>}>
          <ResetPasswordPage />
        </React.Suspense>
      ),
    },
  ],
};
